import * as React from 'react'

function ExitLink(props) {
  const {url, text} = props;

  return (
      <a href={url} target="_blank" rel="noopener nofollow" className="js-jwplayer__exit-link">{text}</a>
  )
}

export default ExitLink;